import '../sass/app.scss';
import Vue from 'vue/dist/vue.esm';
import * as uiv from 'uiv';
import "@babel/polyfill";

// Charger les fichiers javascripts globaux.
require('./bootstrap');
window.Commons = require('./commons');

window.L = function (key) {
  if (window.languageKeys[key] == undefined) {
    return "<span style='color: red'>" + key + "</span>";
  }
  return window.languageKeys[key];
}

Vue.use(uiv);

// DÉFINIR LES COMPOSANTES ICI.
Vue.component('sales-grid', require('../components/SalesGrid.vue').default);
Vue.component('sales-grid-customer-box', require('../components/SalesGridCustomerBox.vue').default);
Vue.component('date-picker', require('../components/DatePicker.vue').default);

Vue.mixin({
  methods: {
    L: str => window.L(str),
    __: str => window.L(str)
  }
})

window.refreshVue = function (selector) {

  $(selector).find(".vue-enabled").each(function () {
    var vm = new Vue({
      el: this
    });
  })

}

$(function () {
  refreshVue("body");
});

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}